<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">International Shipment Orders</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            deliver_to_pending_to_branch: 'deliver_to_pending_to_branch',
            generate_qr_code: 'shipment_generate_qrcode'
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addSendToPendingToBranchButton="true"
          :openSendToPendingToBranchModal="openSendToPendingToBranchModal"
          :addSendToErbilButton="true"
          :openSendToErbilModal="openSendToErbilModal"
          :tableData="tableData"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :getByWarehouse="getByWarehouse"
          :addQrCodeGenerateButton="true"
          :openGenerateQrCodeModal="openGenerateQrCodeModal"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12" v-if="$_has_perm('deliver_to_pending_to_branch')">
          <form @submit.prevent="scanQrCode" class="form-inline" style="margin: 8px 0 15px">
            <input ref="scanInput" v-model.trim="scanCode" type="text" class="form-control" placeholder="Scan QR code" />
            <button class="btn btn-primary" type="submit">Scan</button>
            <select v-model="scanPalletId" class="form-control" style="margin-left: 12px; appearance: auto; -webkit-appearance: menulist" title="Only for an order that was not sent from the warehouse: the pallet it came on">
              <option :value="null">Pallet of a forgotten order</option>
              <option v-for="p in scanPallets" :key="p.pallet_id" :value="p.pallet_id">{{ p.origin }} · {{ p.tracking_number }}{{ p.flight_date ? ' (' + p.flight_date + ')' : '' }}</option>
            </select>
            <span style="margin-left: 12px">{{ qrCodeValues.length }} selected</span>
          </form>
        </div>
        <div v-if="unpaidNotice" class="unpaid-notice">
          {{ unpaidNotice }}<br />Sent to Pending to Branch
        </div>
        <!-- :intShipment="true" -->
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>

          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="qrCodeValues.find(x => x[0] == r.order_id) ? 'background-color: #FFF9C4' : '' "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[
                      r.order_id,
                      r.full_name,
                      r.phone_number,
                      r.user_id,
                      r.theOrderID,
                      r.is_ship_only,
                      r.product_name,
                    ]"
                    v-model="qrCodeValues"
                    @change="rowTicked(r, $event)"
                  />
                  <!-- r.deliver_branch_name,
                      r.deliver_branch_id_fk, -->
                </td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-users :orderData="r" />
                </td>
                <!-- <td>
                  <display-branch :data="r" />
                </td> -->
                <td><i
                    class="fa fa-qrcode"
                    aria-hidden="true"
                  ></i>{{ r.order_id }}</td>
                <td>{{ r.theOrderID }}</td>
                <td>
                  <span v-if="r.is_ship_only == 1" class="ship-only-label">Ship Only</span>
                </td>
                <td>{{ r.customer_id_fk }}</td>
                <td class="ws-nowrap">
                  <i v-if="r.fcm_token" class="material-icons customer-device-icon">smartphone</i> <i v-else class="material-icons customer-device-icon">language</i>                   <img v-if="r.profile_image" :src="`${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                    {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                  </span>
                  <span v-else>
                    {{ r.full_name }}
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                      (r.product_url.length > 10 ? '...' : '')
                  }}</a>
                </td>
                <td>{{
                  r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : '')
                }}</td>
                <td>{{ r.quantity }}</td>
                <td>{{ r.country }}</td>
                <td>{{ r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : '' }}</td>
                <td>{{ r.purchase_note }}</td>
                <td>{{ r.note }}</td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-dates :orderData="r" />
                </td>
                <td>{{ r.bank_name }}</td>
                <td
                  v-if="$_has_perm('view_order_detail')"
                  style="padding-left:10px; padding-right:10px"
                >
                  <a
                    style="color:#01579B"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('deliver_to_pending_to_branch')"
                  style="padding-left:0px; padding-right:10px"
                >
                  <a
                    style="color:#EE4545"
                    tooltip="Deliver to pending to branch"
                    @click="deliverToPendingToBranch(r.order_id)"
                  >
                    <i class="material-icons">local_shipping</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('return_shipment_order_to_purchased_order')"
                  style="padding-left:0px; padding-right:10px"
                >
                  <a
                    style="color:#eb8545"
                    tooltip="Return to purchase"
                    @click="returnToPurchase(r.order_id)"
                  >
                    <i class="material-icons">settings_backup_restore</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            :isPurchase="true"
            :isOrder="true"
            v-if="isMobile"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID]"
                    v-model="qrCodeValues"
                    @change="rowTicked(r, $event)"
                  />
                </td>
                <td>
                  <i
                    class="fa fa-qrcode"
                    aria-hidden="true"
                  ></i> {{ r.order_id }} , <br />
                  {{ r.theOrderID }} , <br />
                  {{
                    r.product_name.substr(0, 35) +
                      (r.product_name.length > 35 ? '...' : '')
                  }} , <br />
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                      (r.product_url.length > 10 ? '...' : '')
                  }}</a>
                  <br />
                  {{ r.country }} ,
                  <br />
                  purchaseNote: {{ r.purchase_note }}
                  <br />
                  Quantity: {{ r.quantity }}
                </td>
                <td>
                  Customer name: {{ r.full_name }} , <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else>{{ r.created_at }}</span> <br />
                  Confirm date: {{ r.confirm_date }} , <br />
                  <a
                    v-if="$_has_perm('view_order_detail')"
                    style="color:#01579B; display: inline-block; padding-right: 3px"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                  <span
                    v-if="$_has_perm('deliver_to_pending_to_branch')"
                    style="padding-left:0px; padding-right:5px; float: left"
                  >
                    <a
                      style="color:#EE4545"
                      tooltip="Deliver to pending to branch"
                      @click="deliverToPendingToBranch(r.order_id)"
                    >
                      <i class="material-icons">local_shipping</i>
                    </a>
                  </span>
                  <span
                    v-if="$_has_perm('return_shipment_order_to_purchased_order')"
                    style="padding-left:0px; padding-right:5px; float: left"
                  >
                    <a
                      style="color:#eb8545"
                      tooltip="Return to purchase"
                      @click="returnToPurchase(r.order_id)"
                    >
                      <i class="material-icons">settings_backup_restore</i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <send-to-pending-to-branch
            :sendToPendingToBranchData="sendToPendingToBranchData"
            :sendToPendingToBranch="sendToPendingToBranch"
            :sendToPendingToBranchModal="sendToPendingToBranchModal"
            :openSendToPendingToBranchModal="openSendToPendingToBranchModal"
            :closeSendToPendingToBranchModal="closeSendToPendingToBranchModal"
          >
          </send-to-pending-to-branch>

          <v-dialog v-model="sendToErbilModal" persistent max-width="650px">
            <v-card>
              <v-card-title>
                <span class="headline">Send to Delivered to Erbil ({{ qrCodeValues.length }})</span>
              </v-card-title>
              <v-card-text>
                <div class="d-flex align-center">
                  <img src="../../assets/images/whatsapp.png" style="width: 32px; margin-top: -10px" alt="whatsapp" class="mr-2">
                  <v-checkbox style="padding: 0px;" label="Send Whatsapp Message" v-model="sendToErbilData.send_sms" color="indigo"></v-checkbox>
                </div>
                <div v-if="sendToErbilData.send_sms">
                  <label style="opacity: 0.8; font-size: 14px">English Message</label>
                  <textarea v-model="sendToErbilData.englishMessage" class="form-control" rows="4" />
                  <label style="opacity: 0.8; font-size: 14px">Arabic Message</label>
                  <textarea v-model="sendToErbilData.arabicMessage" class="form-control" style="direction: rtl" rows="4" />
                  <label style="opacity: 0.8; font-size: 14px">Kurdish Message</label>
                  <textarea v-model="sendToErbilData.kurdishMessage" class="form-control" rows="4" />
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="buttonPadding" @click="sendToErbilModal = false">Cancel</v-btn>
                <v-btn class="buttonPadding" @click="sendToErbilSubmit" color="success">OK</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <create-qr-code
            :openGenerateQrCodeModal="openGenerateQrCodeModal"
            :generateQrCodeModal="generateQrCodeModal"
            :closeGenerateQrCodeModal="closeGenerateQrCodeModal"
            :qrCodeValues="qrCodeValues"
            :generateQrCode="generateQrCode"
            :getResults="getResults"
          ></create-qr-code>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import sendToPendingToBranch from './sendToPendingToBranch.vue'
import mobileDatatable from './mobileDatatable'
import createQrCode from './createQrCode.vue'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'send-to-pending-to-branch': sendToPendingToBranch,
    'mobile-datatable': mobileDatatable,
    'create-qr-code': createQrCode
  },
  created() {
    this.getLoggedInUser()
    if (this.$_has_perm('deliver_to_pending_to_branch')) this.getScanPallets()
  },
  mounted() {
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: 'Check Box', value: '1' },
      {
        label: 'User',
        text: 'User',
        value: '2',
        sortable: false,
        searchable: false,
        name: 'user'
      },
      {
        label: 'Qr ID',
        text: 'Qr ID',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'order_id',
      },
      {
        label: 'OrderID',
        text: 'OrderID',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'theOrderID',
      },
      {
        label: 'Shiponly',
        text: 'Shiponly',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'is_ship_only',
      },
      {
        label: 'Customer ID',
        text: 'Customer ID',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'customer_id_fk',
      },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'full_name',
      },
      {
        label: 'Customer Note',
        text: 'Customer Note',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'customer_note',
      },
      {
        label: 'Product URL',
        text: 'Product URL',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'product_url',
      },
      {
        label: 'Product Name',
        text: 'Product Name',
        value: '10',
        sortable: true,
        searchable: true,
        name: 'product_name',
      },
      {
        label: 'Qty',
        text: 'Qty',
        value: '11',
        sortable: true,
        searchable: true,
        name: 'quantity',
      },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '12',
        sortable: true,
        searchable: true,
        name: 'country',
      },
      {
        label: 'Type',
        text: 'Type',
        value: '13',
        sortable: true,
        searchable: true,
        name: 'transportation_type_obj',
      },
      {
        label: 'Purchase Note',
        text: 'Purchase Note',
        value: '14',
        sortable: true,
        searchable: true,
        name: 'purchase_note',
      },
      {
        label: 'Order Note',
        text: 'Order Note',
        value: '15',
        sortable: true,
        searchable: true,
        name: 'note',
      },
      {
        label: 'Date',
        text: 'Date',
        value: '16',
        sortable: true,
        searchable: true,
        name: 'int_shipment_date',
      },
      {
        label: 'Bank',
        text: 'Bank',
        value: '17',
        sortable: true,
        searchable: true,
        name: 'bank_name',
      },
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/int_shipment_order',
      deliverToPendingToBranchUrl: 'api/deliver_to_pending_to_branch',
      orderDetailUrl: 'api/show_order_detail',
      returnToPurchaseUrl: 'api/orders/',
      sendToPendingToBranchModal: false,
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      generateQrCodeModal: false,
      checkAlert: false,
      btnsave: true,
      queryParameter: true,
      qrCodeValues: [],
      scanCode: '',
      scanQueue: [],
      scanBusy: false,
      scanPallets: [],
      scanPalletId: null,
      checkingAll: false,
      unpaidNotice: '',
      unpaidNoticeTimer: null,
      sendToErbilModal: false,
      sendToErbilData: {
        send_sms: true,
        englishMessage: '',
        arabicMessage: '',
        kurdishMessage: ''
      },
      loggedInUserData: {},
      sendToPendingToBranchData: {
        order_id: '',
        send_sms: false,
      },
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      orderID: [],
      detailResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        warehouse: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: '',
      },
    }
  },
  methods: {
    getScanPallets() {
      const token = localStorage.getItem('access_token')
      axios.get('api/pallets/list', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => { this.scanPallets = response.data })
        .catch(() => {})
    },

    scanQrCode() {
      const code = this.scanCode
      this.scanCode = ''
      if (!/^\d+$/.test(code)) {
        if (code) swal('Error', 'Invalid QR code: ' + code, 'error').then(() => this.focusScanInput())
        return
      }
      this.scanQueue.push(code)
      this.processScanQueue()
    },

    // Scans run one at a time so fast scanner input is not lost; the table reloads after the last one.
    processScanQueue() {
      if (this.scanBusy) return
      if (!this.scanQueue.length) return this.getResults()
      this.scanBusy = true
      const token = localStorage.getItem('access_token')
      // An order the warehouse never sent has no pallet: the server asks for one, picked next to the Scan box.
      axios.put('api/int_shipment_scan/' + this.scanQueue.shift(), { ask_pallet: true, pallet_id: this.scanPalletId }, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          const o = response.data.data
          this.qrCodeValues = this.qrCodeValues.filter(x => x[0] != o.order_id)
          if (o.paid) {
            this.qrCodeValues.push([o.order_id, o.full_name, o.phone_number, o.user_id, o.theOrderID, o.is_ship_only, o.product_name])
          } else {
            this.showUnpaid(o.theOrderID + (o.is_ship_only == 1 ? ' Ship Only' : ' Int shipping not paid'))
          }
        })
        .catch((error) => {
          swal('Error', error.response ? error.response.data.message : 'Scan failed', 'error').then(() => this.focusScanInput())
        })
        .then(() => {
          this.scanBusy = false
          this.processScanQueue()
        })
    },

    focusScanInput() {
      if (this.$refs.scanInput) this.$refs.scanInput.focus({ preventScroll: true })
    },

    rowTicked(r, event) {
      // A single tick on an unpaid order works like a scan; Check All only selects.
      if (!event.target.checked || this.checkingAll) return
      if (r.is_ship_only == 1 || !(Number(r.internal_shipping_handling) > 0)) {
        this.scanQueue.push(r.order_id)
        this.processScanQueue()
      }
    },

    showUnpaid(text) {
      this.unpaidNotice = text
      clearTimeout(this.unpaidNoticeTimer)
      this.unpaidNoticeTimer = setTimeout(() => { this.unpaidNotice = '' }, 2000)
    },

    openSendToErbilModal() {
      if (this.qrCodeValues.length < 1) {
        return swal({ text: 'Please at least select one order!', icon: 'warning', dangerMode: true })
      }
      const token = localStorage.getItem('access_token')
      axios.get('api/whatsapp-message-template', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          const template = response.data.data
          if (template) {
            this.sendToErbilData.englishMessage = template.english_message
            this.sendToErbilData.arabicMessage = template.arabic_message
            this.sendToErbilData.kurdishMessage = template.kurdish_message
          }
        })
        .catch(() => {})
      this.sendToErbilData.send_sms = true
      this.sendToErbilModal = true
    },

    sendToErbilSubmit() {
      const token = localStorage.getItem('access_token')
      const payload = { order_ids: this.qrCodeValues.map(x => x[0]), send_sms: this.sendToErbilData.send_sms }
      if (this.sendToErbilData.send_sms) {
        if (!(this.sendToErbilData.englishMessage || this.sendToErbilData.arabicMessage || this.sendToErbilData.kurdishMessage)) {
          return swal('Error', 'The WhatsApp message is empty', 'error')
        }
        payload.message_template = this.sendToErbilData.englishMessage + '\n\n---\n\n' + this.sendToErbilData.arabicMessage + '\n\n---\n\n' + this.sendToErbilData.kurdishMessage
      }
      axios.put('api/int_shipment_to_erbil', payload, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          const { unpaid, skipped } = response.data.data
          this.sendToErbilModal = false
          this.qrCodeValues = []
          $('#mainCheck').prop('checked', false)
          this.getResults()
          if (skipped) {
            swal('Done', skipped + ' selected orders were no longer in International Shipment and were skipped', 'warning')
          } else if (!unpaid.length) {
            swal({ title: 'Done', text: '', icon: 'success', timer: 1500, buttons: false })
          }
          if (unpaid.length) {
            this.showUnpaid((unpaid.length === 1 ? unpaid[0] : unpaid.length + ' orders') + ' Int shipping not paid')
          }
        })
        .catch((error) => {
          this.sendToErbilModal = false
          this.getResults()
          swal('Error', error.response ? error.response.data.message : 'Failed', 'error')
        })
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    openGenerateQrCodeModal() {
      if (this.qrCodeValues.length < 1) {
        swal({
          text: 'Please at least select one order!',
          icon: 'warning',
          dangerMode: true,
        })
      } else {
        this.generateQrCodeModal = true
      }
    },

    closeGenerateQrCodeModal() {
      this.generateQrCodeModal = false
      this.qrCodeValues = []
    },

    generateQrCode() {
      this.closeGenerateQrCodeModal()
    },

    sendToExport() {
      let arr = ''

      for (let i = 0; i < this.orderID.length; i++) {
        if (i < this.orderID.length - 1) {
          arr = arr.concat('arr[]=' + this.orderID[i] + '&')
        } else {
          arr = arr.concat('arr[]=' + this.orderID[i])
        }
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      window.location.replace(fullHostName + '/api/shipping-export?' + arr)
    },

    getOrderID(orders) {
      this.orderID = []
      for (let i = 0; i < orders.length; i++) {
        this.orderID[i] = orders[i].order_id
      }
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          this.getOrderID(this.apiResults)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(() => { })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.warehouse = ''
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    openSendToPendingToBranchModal() {
      this.sendToPendingToBranchModal = true
    },

    closeSendToPendingToBranchModal() {
      this.sendToPendingToBranchModal = false
      this.sendToPendingToBranchData.order_id = ''
      this.$validator.reset()
    },

    sendToPendingToBranch() {
      let token = localStorage.getItem('access_token')

      axios
        .put(
          this.deliverToPendingToBranchUrl + '/' + this.sendToPendingToBranchData.order_id,
          this.sendToPendingToBranchData,
          {
            headers: { Authorization: 'Bearer ' + token }
          }
        )
        .then((response) => {
          this.sendToPendingToBranchData.order_id = ''
          swal({
            title: 'Success',
            text: 'Sent successfully',
            icon: 'success',
            timer: 1000
          })
          this.getResults()
        })
        .catch((error) => {
          this.sendToPendingToBranchData.order_id = ''
          swal({
            title: 'Error',
            text: error.response.data.message,
            icon: 'error',
            timer: 1000
          })
          this.getResults()
        })
    },

    deliverToPendingToBranch(id) {
      swal({
        title: 'Are you sure?',
        text: 'Once delivered to pending to branch, you will not be able to return this order to this step!',
        icon: 'warning',
        buttons: true
      }).then((willDelete) => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.deliverToPendingToBranchUrl + '/' + id, '', {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(() => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              this.getResults()
              swal('Error', `${error.response.data.message}`, 'error')
            })
        }
      })
    },

    returnToPurchase(id) {
      swal({
        title: 'Are you sure ?',
        text: 'You really want to return this order to Purchased section?',
        icon: 'warning',
        buttons: true,
        className: 'danger-swal'
      }).then((willDelete) => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.returnToPurchaseUrl + id + '/return_to_purchase', '', {
              headers: { Authorization: 'Bearer ' + token },
            })
            .then((response) => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false,
              })
            })
            .catch((error) => {
              if (error.response) {
                swal('Error', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    getByWarehouse(warehouse) {
      this.tableData.warehouse = warehouse
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true,
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },

    checkAll() {
      this.checkingAll = true
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
      this.checkingAll = false
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },
  },
}
</script>

<style>
.ship-only-label {
  display: inline-block;
  padding: 2px 8px;
  border: 2px solid green;
  border-radius: 5px;
  font-weight: bold;
  font-size: 0.9em;
  color: green;
}

.unpaid-notice {
  position: fixed;
  z-index: 10001;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  width: 240px;
  height: 240px;
  border-radius: 50%;
  background: #d32f2f;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  font-size: 18px;
  font-weight: bold;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

.danger-swal {
  background: #ff6262 !important;
}
a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/intShipmentOrder.vue